import { render, staticRenderFns } from "./TheoryRatingEnglish.vue?vue&type=template&id=790ea4b8"
import script from "./TheoryRatingEnglish.vue?vue&type=script&lang=js"
export * from "./TheoryRatingEnglish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports